import { Box, Paper, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import SectionHeader from '@/components/researcher/SectionHeader'
import type { FunnelStep } from './monitoringMockData'

/** Conversion funnel: invited → started → viewed → completed. */
export default function Funnel({ steps }: { steps: FunnelStep[] }) {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('monitoring')

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2.5, borderRadius: '18px', borderColor: 'divider', display: 'flex', flexDirection: 'column', gap: 1.75 }}
    >
      <SectionHeader title={t('funnel.title')} />
      <Stack spacing={1.5}>
        {steps.map((s, i) => {
          const prev = i > 0 ? steps[i - 1] : null
          const drop = prev ? prev.n - s.n : 0
          return (
            <Stack key={s.key} spacing={0.75}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <Typography sx={{ fontSize: 13, color: c.ink, fontWeight: 500 }}>
                  {t(`funnel.steps.${s.key}`)}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'baseline' }}>
                  <Typography sx={{ fontWeight: 700, fontSize: 18, fontVariantNumeric: 'tabular-nums', color: c.ink }}>
                    {s.n}
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: c.ink56, fontVariantNumeric: 'tabular-nums' }}>
                    {s.pct}%
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ height: 8, bgcolor: c.gray100, borderRadius: 34, overflow: 'hidden' }}>
                <Box
                  sx={{
                    width: `${s.pct}%`,
                    height: '100%',
                    background: `linear-gradient(90deg, ${c.coral}, ${c.coral300})`,
                  }}
                />
              </Box>
              {drop > 0 && prev && (
                <Typography sx={{ fontSize: 11, color: c.ink56, fontVariantNumeric: 'tabular-nums' }}>
                  {t('funnel.dropped', { count: drop, pct: Math.round((drop / prev.n) * 100) })}
                </Typography>
              )}
            </Stack>
          )
        })}
      </Stack>
    </Paper>
  )
}
